module.exports = __webpack_public_path__ + "system/img/404-01.b37c13e5.png";